import axiosInstance from "../api/axiosInstance";
import { apiList } from "../api/apiList";

const companyService = {
  getCompanies: () => axiosInstance.get(apiList.companyApi),
};

export default companyService;
